import React, { FC } from 'react'
import { makeStyles } from 'tss-react/mui'

import { ImagePayload } from '../../nodes/ImageNode/ImageNode'
import { FormValidationError } from './validation'
import { InputType, TextField } from '../../../InputFields/TextField'

const useStyles = makeStyles()(theme => ({
  field: {
    '& .MuiInputBase-root': {
      fontSize: theme.shape.inputField.fontSize,
    },
  },
}))

interface FormFieldProps {
  onChange: (value: string, key: keyof ImagePayload) => void
  value: string
  fieldKey: keyof ImagePayload
  error: FormValidationError
  placeholder: string
  label: string
  type?: InputType
  endAdornment?: React.ReactElement
}

/**
 * Reused text field for insert image dialog
 */
export const FormField: FC<FormFieldProps> = ({ error, fieldKey, onChange, value, label, placeholder, type, endAdornment }) => {
  const { classes } = useStyles()

  return (
    <TextField
      label={label}
      placeholder={placeholder}
      onChange={e => {
        onChange(e, fieldKey)
      }}
      value={value}
      error={error?.issues.some(issue => issue.path[0] === fieldKey) ?? false}
      helperText={error?.issues.find(issue => issue.path[0] === fieldKey)?.message}
      type={type}
      key={fieldKey}
      className={classes.field}
      endAdornment={endAdornment}
    />
  )
}
